import React from 'react';
import {st, classes} from './Header.st.css';
import {StoreNameAndLogo} from '../../../common/components/StoreNameAndLogo/StoreNameAndLogo';
import {hexToRgb} from '../../../domain/utils/colors';
import {CheckoutSettingsModel} from '../../../domain/models/checkout/checkoutSettings/CheckoutSettings.model';
import {useControllerProps} from '../Widget/ControllerContext';

export enum HeaderDataHooks {
  ContinueShoppingButton = 'HeaderDataHooks.ContinueShoppingButton',
  Divider = 'HeaderDataHooks.Divider',
}

export interface HeaderProps {
  dataHook: string;
  titleSuffixOverride?: string;
  checkoutSettings: CheckoutSettingsModel;
  isOneColumnView?: boolean;
  continueShoppingUrl?: string;
  clickOnContinueShopping?: () => void;
  HeaderSuffix?: React.FC;
  HeaderAfter?: React.FC;
}

export const Header = ({
  dataHook,
  titleSuffixOverride,
  checkoutSettings,
  isOneColumnView,
  continueShoppingUrl,
  clickOnContinueShopping,
  HeaderSuffix,
  HeaderAfter,
}: HeaderProps) => {
  const {navigationStore} = useControllerProps();

  const backgroundColor = checkoutSettings?.checkoutHeader?.backgroundFill?.color;
  const textColor = checkoutSettings?.checkoutHeader?.textColor;

  const headerStyle = {
    '--headerBackground': backgroundColor,
    '--headerTextColor': textColor,
    '--headerTextColor-rgb': hexToRgb(textColor),
  } as React.CSSProperties;

  if (navigationStore?.isHeaderSectionHidden) {
    return null;
  }

  return (
    <div className={classes.header} style={headerStyle}>
      <div className={st(classes.innerHeader)} data-hook={dataHook}>
        <StoreNameAndLogo
          continueShoppingUrl={continueShoppingUrl}
          clickOnContinueShopping={clickOnContinueShopping}
          logoUrl={checkoutSettings?.logoUrl}
          storeName={checkoutSettings?.storeName}
          checkoutHeader={checkoutSettings?.checkoutHeader}
          isOneColumnView={isOneColumnView}
          titleSuffixOverride={titleSuffixOverride}
        />
        {HeaderSuffix && <HeaderSuffix />}
      </div>
      {HeaderAfter && <HeaderAfter />}
      <div className={classes.divider} data-hook={HeaderDataHooks.Divider} />
    </div>
  );
};
